import config from 'config'
import { Redirect } from 'react-router-dom'
import { Main } from 'components/masters'
import { get } from 'lodash'
import React from 'react'
import { Tabs } from 'components/layout'
import * as Page from 'containers/pages'


const publicPath = config.publicPath
const routes = [
  {
    path: `${publicPath}/message-center`,
    exact: true,
    component: () => (
        <Redirect to={`${publicPath}/message-center/my-messages`} />
    )
  },
  {
    path: `${publicPath}/message-center/my-messages`,
    exact: true,
    component: props => (
        <Main {...props} params={get(props, 'match.params', {})}>
          <Page.Messages
              {...props}
              params={get(props, 'match.params', {})}
              tabs={<Tabs {...props} params={get(props, 'match.params', {})} />}>
            <Page.MyMessages {...props} params={get(props, 'match.params', {})} />
          </Page.Messages>
        </Main>
    )
  },
    {
        path: `${publicPath}/message-center/all-messages`,
        exact: true,
        component: props => (
            <Main {...props} params={get(props, 'match.params', {})}>
                <Page.Messages
                    {...props}
                    params={get(props, 'match.params', {})}
                    tabs={<Tabs {...props} params={get(props, 'match.params', {})} />}>
                    <Page.AllMessages {...props} params={get(props, 'match.params', {})} />
                </Page.Messages>
            </Main>
        )
    }
]

export default routes
